import { render, staticRenderFns } from "./Sim.vue?vue&type=template&id=0eb95daa&scoped=true&"
import script from "./Sim.vue?vue&type=script&lang=js&"
export * from "./Sim.vue?vue&type=script&lang=js&"
import style0 from "./Sim.vue?vue&type=style&index=0&id=0eb95daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb95daa",
  null
  
)

export default component.exports